/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "368")




export interface API46859Req {
  
  /** 合同模板编号 */
  templateNo?: string;
  /** 合同编号 */
  contractNo?: string;
  /** 合同基础信息 ,ContractBaseInfoParam */
  baseInfoParam?: any;
  /** 提交合同状态,-1,pdf合同预览0,"待提交"；1,"待审核",AuditStatusEnum */
  auditStatus?: number;
  /** 合同参数(该参数为map) */
  formDetail?: any;
  /** 审批节点 ,ContractNodeModel */
  nodeList?: any[];
  /** 资质文件列表 ,ContractFileOfGroupParam */
  fileList?: any[];
  /** 删除的资质文件编号列表 ,String */
  deleteFileNoList?: any[];
  /** 线下合同文件列表 ,ContractOfflineFileParam */
  offlineFileList?: any[];
  /** 商品列表 ,ContractItemFormParam */
  itemList?: any[];
  /** 合同模板档案编号 */
  archiveNo?: string;
};



export type API46859Res = {};


// 46859 新增、编辑合同

export interface IUsePostAPI46859Return {
  /** 新增、编辑合同: 接口请求状态 */
  isAPI46859Loading: boolean;
  /** 新增、编辑合同: 接口请求返回数据 */
  dataAPI46859: API46859Res;
  /**  新增、编辑合同: 接口数据请求方法 */
  fetchAPI46859Data:  (inputs: API46859Req, config?: YWRequestConfig) => Promise<API46859Res>;
  /** 新增、编辑合同: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI46859 = ():IUsePostAPI46859Return => {
  let isMount = true;
  const [isAPI46859Loading, setIsAPI46859Loading] = useState(false);
  const [dataAPI46859, setDataAPI46859] = useState<API46859Res>({} as API46859Res);
  const requestUrl = `${basePath}/internal-control-biz/new/admin/supplier/contract/v1/saveOrEdit`;

  const fetchAPI46859Data = async (inputs: API46859Req, config?: YWRequestConfig): Promise<API46859Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API46859Req>) || {}) as API46859Req;
    
  
    if ( isMount ) {
      setIsAPI46859Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API46859Res>(`${basePath}/internal-control-biz/new/admin/supplier/contract/v1/saveOrEdit`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI46859(res || {} as API46859Res);
        setIsAPI46859Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI46859Loading(false);
      }
      return false as unknown as API46859Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI46859Loading,
    dataAPI46859,
    fetchAPI46859Data,
    requestUrl,
  }
}

